import { api } from '@features';

import {
  IMetricsBandwidthInstance,
  IMetricsDaily,
  IMetricsLive,
  IMetricsPeakHourRegion,
  IMetricsSpawns,
  IMetricsSummary,
  IMetricsTimeseries,
} from './Metrics';

const unwrap = <T>(key: string) => (response: any): T => {
  if (response && response.success) {
    return response[key];
  }
  return Promise.reject('Unauthorized') as any;
};

export const metricsApi = api.injectEndpoints({
  endpoints: (builder) => ({
    getMetricsSummary: builder.query<IMetricsSummary, void>({
      query: () => ({ method: 'GET', url: `/metrics/summary` }),
      extraOptions: { maxRetries: 0 },
      providesTags: ['Metrics'],
      transformResponse: unwrap<IMetricsSummary>('summary'),
    }),
    getMetricsTimeseries: builder.query<IMetricsTimeseries, number | void>({
      query: (hours) => ({ method: 'GET', url: `/metrics/timeseries?hours=${hours || 24}` }),
      extraOptions: { maxRetries: 0 },
      providesTags: ['Metrics'],
      transformResponse: (response: any) => response,
    }),
    getMetricsDaily: builder.query<IMetricsDaily, number | void>({
      query: (days) => ({ method: 'GET', url: `/metrics/daily?days=${days || 30}` }),
      extraOptions: { maxRetries: 0 },
      providesTags: ['Metrics'],
      transformResponse: (response: any) => response,
    }),
    getMetricsLive: builder.query<IMetricsLive, void>({
      query: () => ({ method: 'GET', url: `/metrics/live` }),
      extraOptions: { maxRetries: 0 },
      providesTags: ['Metrics'],
      transformResponse: (response: any) => response,
    }),
    getMetricsPeakHours: builder.query<{ days: number; regions: IMetricsPeakHourRegion[] }, number | void>({
      query: (days) => ({ method: 'GET', url: `/metrics/peakhours?days=${days || 14}` }),
      extraOptions: { maxRetries: 0 },
      providesTags: ['Metrics'],
      transformResponse: (response: any) => response,
    }),
    getMetricsSpawns: builder.query<IMetricsSpawns, number | void>({
      query: (days) => ({ method: 'GET', url: `/metrics/spawns?days=${days || 30}` }),
      extraOptions: { maxRetries: 0 },
      providesTags: ['Metrics'],
      transformResponse: (response: any) => response,
    }),
    getMetricsBandwidth: builder.query<{ instances: IMetricsBandwidthInstance[] }, void>({
      query: () => ({ method: 'GET', url: `/metrics/bandwidth` }),
      extraOptions: { maxRetries: 0 },
      providesTags: ['Metrics'],
      transformResponse: (response: any) => response,
    }),
  }),
});

export const {
  useGetMetricsSummaryQuery,
  useGetMetricsTimeseriesQuery,
  useGetMetricsDailyQuery,
  useGetMetricsLiveQuery,
  useGetMetricsPeakHoursQuery,
  useGetMetricsSpawnsQuery,
  useGetMetricsBandwidthQuery,
} = metricsApi;
